import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import socketMiddleware from './socket';
import RootReducer from './reducers';
import { SERVER_URL } from '../constants/system.keys';
import rootSaga from './saga';
const sagaMiddleware = createSagaMiddleware();

const middlewareSaga = applyMiddleware(sagaMiddleware);

const middleware = applyMiddleware(
  thunkMiddleware,
  socketMiddleware(SERVER_URL),
);

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['recovery'],
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

const Store = createStore(
  persistedReducer,
  composeWithDevTools(middlewareSaga, middleware),
);

sagaMiddleware.run(rootSaga);
export const persistor = persistStore(Store);
export default Store;
